import "./styles.scss";

import { Formik, Form } from "formik";
import { useTranslation } from "react-i18next";

import ModalNew from "components/ModalNew";
import FormikInput from "components/formik/FormikInput";
import PasswordValidator from "components/PasswordValidator";

import changePasswordSchema from "libs/validations/changePasswordSchema";

const mainClass = "change-password-modal";

const ChangePasswordModal = ({
  changePassword,
  includeOldPassword = true,
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();

  const onSubmit = async (values, setSubmitting, setErrors, resetForm) => {
    try {
      if (typeof changePassword === "function") await changePassword(values);

      resetForm();
      onClose();
    } catch (err) {
      if (err?.response?.data?.type === "wrong_password") {
        setErrors({ old_password: err?.response?.data?.error });
      }
    }

    setSubmitting(false);
  };

  return (
    <Formik
      initialValues={{
        old_password: "",
        new_password: "",
        new_password2: "",
      }}
      validationSchema={changePasswordSchema(includeOldPassword)}
      onSubmit={(values, { setSubmitting, setErrors, resetForm }) => {
        onSubmit(values, setSubmitting, setErrors, resetForm);
      }}
    >
      {({ values, isSubmitting, submitForm }) => (
        <ModalNew
            title={t("Change password")}
            description={t(
              includeOldPassword
                ? "Update your panel password"
                : "Update the password for the panel",
            )}
            loading={isSubmitting}
            isOpen={isOpen}
            onClose={onClose}
            onSubmit={submitForm}
          >
            <Form autoComplete="off">
            <div className={`${mainClass} form`}>
              {includeOldPassword && (
                <FormikInput
                  name="old_password"
                  label={t("Current password")}
                  type="password"
                  placeholder="****************"
                  disabled={isSubmitting}
                />
              )}
              <FormikInput
                name="new_password"
                label={t("New password")}
                type="password"
                placeholder="****************"
                disabled={isSubmitting}
              />
              <FormikInput
                name="new_password2"
                label={t("Repeat new password")}
                type="password"
                placeholder="****************"
                disabled={isSubmitting}
              />
              <PasswordValidator
                password={values?.new_password}
                variant="checkmarks"
                hasProgress
              />
            </div>
            </Form>
          </ModalNew>
      )}
    </Formik>
  );
};

export default ChangePasswordModal;
